import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getallDataForConfirmationFunc } from "../../../../../data-store/actions/registry-actions";
import RegistryConfirmation from "./RegistryConfirmation";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";
import OpenpayReturnInWeb from "../PaymentViews/OpenpayReturnInWeb";
import EventRegistryPublicForm from "../EventRegistryPublicForm"
import RegistryConfirmationIncompletePayment from "./RegistryConfirmationIncompletePayment";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    maxWidth: 500,
    backgroundColor: theme.palette.background.paper,
    margin: "0px",
  },
  paper: {
    padding: "0px",
    backgroundColor: "#283747",
  },
  color: {
    padding: "0px",
    backgroundColor: theme.palette.primary.main,
  },
}));

export default function RegistryConfirmationPublic(props) {
  const { event, registry, secure3d } = props;
  const dispatch = useDispatch();

  //const athleteAccount = useSelector((state) => state.atlete.atleteAccount);
  const eventDetail = useSelector((state) => state.events.eventDetail);
  const registryParticipantDataConfirm = useSelector(
    (state) => state.registry.registryParticipantData
  );
  const eventSubEventsRegistry = useSelector(
    (state) => state.events.eventSubEventsRegistry
  );
  const registryConfiguration = useSelector(
    (state) => state.registry.registryConfiguration
  );
  const classes = useStyles();
  const { t } = useTranslation("inscripcion");

  useEffect(() => {
    const unsubscribe = dispatch(
      getallDataForConfirmationFunc(event, registry)
    );

    return () => {
      if (unsubscribe) unsubscribe();
    };
  }, [event, registry]);

  console.log("registryParticipantDataConfirm", registryParticipantDataConfirm, eventDetail)

  if (secure3d) {
    return (
      <OpenpayReturnInWeb eventDetail={eventDetail} order={registryParticipantDataConfirm.order} />
      // <Typography color="primary" component="h1" variant="h6">
      //   3d secure
      // </Typography>
    );

  }



  if (
    !registryParticipantDataConfirm ||
    !eventSubEventsRegistry ||
    !registryConfiguration
  ) {
    return (
      <Typography color="primary" component="h1" variant="h6">
        {t("cargando")}
      </Typography>
    );
  }

  //  <EventRegistryPublicForm order={registryParticipantDataConfirm} />


  if (registryParticipantDataConfirm && registryParticipantDataConfirm.statusPago && registryParticipantDataConfirm.statusPago.status !== "ok") {
    return (<RegistryConfirmationIncompletePayment
      registryParticipantDataConfirm={registryParticipantDataConfirm}
      registryParticipantKeyConfirm={registry}
      registryConfiguration={registryConfiguration}
      eventSubEventsRegistry={eventSubEventsRegistry}
      eventDetail={eventDetail}
      download={true}
      tipo={0}
    />

    );
  }
  return (
    <RegistryConfirmation
      registryParticipantDataConfirm={registryParticipantDataConfirm}
      registryParticipantKeyConfirm={registry}
      registryConfiguration={registryConfiguration}
      eventSubEventsRegistry={eventSubEventsRegistry}
      eventDetail={eventDetail}
      download={true}
      tipo={1}
    />
  );
}
